/**
 * Public origin for SparkSeller Connect. Override with REACT_APP_CONNECT_URL.
 */
export function getConnectAppUrl() {
  const configured = process.env.REACT_APP_CONNECT_URL;
  if (configured) return configured.replace(/\/$/, "");

  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  if (projectId === "sparkseller-connect-prod") return "https://sparkseller.com";
  if (projectId === "sparkseller-connect-staging") {
    return "https://sparkseller-connect-staging.web.app";
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") return "http://localhost:3000";
    if (host.includes("staging")) return "https://sparkseller-connect-staging.web.app";
  }

  return "https://sparkseller.com";
}
